module.exports = __webpack_public_path__ + "img/data-manipulation.ec1ecf10.png";